import { useCallback, useEffect, useState } from 'react';

export function useMeasure(ref) {
  const [offsets, setOffsets] = useState({
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    width: 0,
    height: 0,
  });

  const measure = useCallback(() => {
    if (!ref.current) return;

    const rect = ref.current.getBoundingClientRect();

    setOffsets({
      top: rect.top,
      left: rect.left,
      width: rect.width,
      height: rect.height,
      right: window.innerWidth - rect.right,
      bottom: window.innerHeight - rect.bottom,
    });
  }, [ref]);

  useEffect(() => {
    measure();

    let resizeObserver;
    if (typeof ResizeObserver !== 'undefined' && ref.current) {
      const node = ref.current; // capture at effect run time
      resizeObserver = new ResizeObserver(measure);
      resizeObserver.observe(node);

      return () => {
        resizeObserver.unobserve(node); // use captured value, not ref.current
        resizeObserver.disconnect();
      };
    }
  }, [measure, ref]);

  return offsets;
}
